import { Suspense } from 'react'

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/dialog/dialog'
import { LoadingSpinner } from '@/components/loading-spinner/loading-spinner'

import { cn } from '@/lib/utils'

import { CategoryList } from './category-list/category-list'
import { useCategoryDeleteDialog } from './use-category-delete-dialog'

export interface CategoryDeleteDialogProps {
  open: boolean
  onClose: VoidFunction
}

export const CategoryDeleteDialog = ({ open, onClose }: CategoryDeleteDialogProps) => {
  const { handleChangeDialogOpen } = useCategoryDeleteDialog({
    onClose,
  })

  return (
    <Dialog open={open} onOpenChange={handleChangeDialogOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Category</DialogTitle>
          <DialogDescription className={cn('sr-only')}>
            You can delete categories that are no longer being used. Please select the category you want to delete.
          </DialogDescription>
        </DialogHeader>

        <div>
          <p className={cn('text-sm leading-6')}>
            Only categories that do not include cases are displayed and can be deleted.
          </p>
          <div className={cn('mt-4')}>
            <Suspense fallback={<LoadingSpinner classNames={{ wrapper: cn('flex justify-center') }} />}>
              <CategoryList onSuccessDeleteCategory={onClose} />
            </Suspense>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
